// extracted by mini-css-extract-plugin
export default {"title":"Dashboard_title__+8AkY","count":"Dashboard_count__6ZyoU"};